import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Spinner,
  Typography,
} from "@material-tailwind/react";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { replaceUserSticker } from "../../../redux/actions/stickers_action";

const fileBaseUrl = "https://gbafilesalt.blob.core.windows.net/storage";

function ReplaceButton({ sticker }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [qty, setQty] = useState("1");
  const [replacementReason, setReplacementReason] = useState("");
  const [replacementFile, setReplacementFile] = useState(null);

  const dispatch = useDispatch();

  const handleOpen = () => setOpen((prev) => !prev);

  const resetForm = () => {
    setQty("1");
    setReplacementReason("");
    setReplacementFile(null);
  };

  const handleClose = () => {
    if (!loading) {
      resetForm();
      setOpen(false);
    }
  };

  const handleFileChange = (e) => {
    setReplacementFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    const selectedQty = parseInt(qty);
    const reason = replacementReason.trim();

    if (!selectedQty || selectedQty < 1 || selectedQty > 2) {
      toast.error("Please enter a sticker quantity of 1 or 2.");
      return;
    }

    if (!reason) {
      toast.error("Please provide a replacement reason.");
      return;
    }

    if (!replacementFile) {
      toast.error("Please upload a replacement image.");
      return;
    }

    setLoading(true);

    const result = await dispatch(
      replaceUserSticker(
        sticker.id,
        {
          qty: selectedQty,
          replacement_reason: reason,
        },
        replacementFile,
      ),
    );

    setLoading(false);

    if (!result?.error) {
      handleClose();
    }
  };

  const renderFileLink = (label, file) => {
    if (!file) {
      return (
        <Typography color="blue-gray" className="font-medium">
          Not available
        </Typography>
      );
    }

    return (
      <a
        href={`${fileBaseUrl}/${file}`}
        target="_blank"
        rel="noreferrer"
        className="text-blue-600 font-medium"
      >
        View {label}
      </a>
    );
  };

  return (
    <>
      <Button color="blue-gray" onClick={handleOpen}>
        Replace Sticker
      </Button>

      {open && (
        <Dialog
          open={open}
          handler={handleClose}
          size="xs"
          animate={{
            mount: { opacity: 1, y: 0 },
            unmount: { opacity: 0, y: -50 },
          }}
        >
          <DialogHeader>Replace Sticker</DialogHeader>

          <DialogBody className="max-h-[75vh] overflow-y-auto">
            {/* <Typography color="black" className="mb-6">
              Original sticker details
            </Typography> */}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div>
                <Typography variant="small" color="blue-gray">
                  Plate A
                </Typography>
                <Typography color="black" className="font-medium uppercase">
                  {sticker?.plate_a || "N/A"}
                </Typography>
              </div>

              <div>
                <Typography variant="small" color="blue-gray">
                  Plate B
                </Typography>
                <Typography color="black" className="font-medium">
                  {sticker?.plate_b || "N/A"}
                </Typography>
              </div>

              <div>
                <Typography variant="small" color="blue-gray">
                  Plate C
                </Typography>
                <Typography color="black" className="font-medium">
                  {sticker?.plate_c || "N/A"}
                </Typography>
              </div>
            </div>

            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              <div>
                <Typography variant="small" color="blue-gray">
                  Vehicle Registration Document
                </Typography>
                {renderFileLink("document", sticker?.docs)}
              </div>

              <div>
                <Typography variant="small" color="blue-gray">
                  Supporting Document
                </Typography>
                {renderFileLink("file", sticker?.files)}
              </div>
            </div> */}

            <div className="grid grid-cols-1 gap-5">
              <label className="block">
                <Typography variant="small" color="blue-gray" className="mb-2">
                  Quantity
                </Typography>
                <input
                  type="number"
                  min="1"
                  max="2"
                  value={qty}
                  onChange={(e) => setQty(e.target.value)}
                  required
                  className="w-full rounded-md border border-blue-gray-200 bg-white px-3 py-2 text-sm text-blue-gray-700 outline-none focus:border-gray-900"
                />
              </label>

              <label className="block">
                <Typography variant="small" color="blue-gray" className="mb-2">
                  Reason for Replacement
                </Typography>
                <textarea
                  value={replacementReason}
                  onChange={(e) => setReplacementReason(e.target.value)}
                  required
                  rows={4}
                  className="w-full rounded-md border border-blue-gray-200 bg-white px-3 py-2 text-sm text-blue-gray-700 outline-none focus:border-gray-900"
                />
              </label>

              <label className="block">
                <Typography variant="small" color="blue-gray" className="mb-2">
                  Evidence of Damage
                </Typography>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  required
                  className="w-full rounded-md border border-blue-gray-200 bg-white px-3 py-2 text-sm text-blue-gray-700 outline-none file:mr-4 file:rounded-md file:border-0 file:bg-blue-gray-50 file:px-3 file:py-2 file:text-sm file:font-medium file:text-blue-gray-700"
                />
              </label>
            </div>
          </DialogBody>

          <DialogFooter>
            <Button
              variant="text"
              color="red"
              onClick={handleClose}
              className="mr-1"
              disabled={loading}
            >
              Close
            </Button>

            <Button
              onClick={handleSubmit}
              disabled={loading}
              className="flex items-center gap-3"
            >
              {loading && <Spinner className="h-4 w-4" />}
              Submit Replacement Request
            </Button>
          </DialogFooter>
        </Dialog>
      )}
    </>
  );
}

export default ReplaceButton;
